import React from 'react';

import { useAgeAssurance } from '../hooks/use-age-assurance';

import { AgeAssuranceBlockedScreen } from './age-assurance-blocked-screen';
import { AgeAssurancePendingScreen } from './age-assurance-pending-screen';
import { AgeAssuranceSharingRequiredScreen } from './age-assurance-sharing-required-screen';

type AgeAssuranceGateProps = {
  children: React.ReactNode;
};

export const AgeAssuranceGate = ({ children }: AgeAssuranceGateProps) => {
  const { state, blockedReason, retry } = useAgeAssurance();

  if (state === 'pending') {
    return <AgeAssurancePendingScreen />;
  }

  if (state === 'blocked') {
    if (blockedReason === 'age_sharing_required') {
      return <AgeAssuranceSharingRequiredScreen onRetry={() => void retry()} />;
    }
    return <AgeAssuranceBlockedScreen onRetry={() => void retry()} />;
  }

  return <>{children}</>;
};
